module.exports = __webpack_public_path__ + "step5_child_to_parent_son.72092171.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step5_child_to_parent_son.jpg
// module id = FEwh
// module chunks = 0